import React from "react";
import GestureButton from "./GestureButton";
import { Action } from "../karaoke/actions";

// Simplified: StartControl only renders the START trigger. Recording/paused visual state moved to RecordingIndicator.
export default function StartControl({ activeAction, onTrigger, className, isRecording }) {   
  return (
    <GestureButton
      action={Action.START}
      label={isRecording ? "Stop live read" : "Start live read"}
      emoji="👍"
      activeAction={activeAction}
      onTrigger={onTrigger}
      className={className}
    />
  );
}
